import { render } from "./BannerButton.vue?vue&type=template&id=a0f7c9ce"
import script from "./BannerButton.vue?vue&type=script&lang=js"
export * from "./BannerButton.vue?vue&type=script&lang=js"

import "./BannerButton.vue?vue&type=style&index=0&id=a0f7c9ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__